import NavigateBackWizardStep from "../../components/navigateBackWizardStep";
import { useWizard } from "react-use-wizard";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import createPersistedState from "use-persisted-state";
import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
const useClinicState = createPersistedState("clinic");

const clinicTranslationMap = {
  CC000001: "appointment.CLINIC.clinic1",
  CC000002: "appointment.CLINIC.clinic2",
  CC000003: "appointment.CLINIC.clinic3",
  CC000004: "appointment.CLINIC.clinic4",
  CC000005: "appointment.CLINIC.clinic5",
};

const SelectClinicStep = ({
  selectClinic,
  availableClinics,
  patientDefaultClinic,
}) => {
  const { previousStep, nextStep } = useWizard();
  const { t } = useTranslation();
  const [clinicId, setClinic] = useClinicState();
  const { search } = useLocation();

  const isReschedule = new URLSearchParams(search).get("reschedule");
  const isOnline = new URLSearchParams(search).get("online");

  const [isOnlineAppointmentAvailable, setIsOnlineAppointmentAvailable] =
    useState(false);

  useEffect(() => {
    availableClinics?.filter((clinic) => clinic.online).length > 0
      ? setIsOnlineAppointmentAvailable(true)
      : setIsOnlineAppointmentAvailable(false);
  }, []);

  const filteredClinics = useMemo(() => {
    //Disabling the filtering of clinics based on patient default clinic

    // if (
    //   patientDefaultClinic &&
    //   availableClinics.some((clinic) => clinic.code === patientDefaultClinic)
    // ) {
    //   return availableClinics.filter(
    //     (clinic) => clinic.code === patientDefaultClinic
    //   );
    // }
    return availableClinics;
  }, [availableClinics, patientDefaultClinic]);

  return (
    <>
      <NavigateBackWizardStep
        clickHandler={() => previousStep()}
        title={t("appointment.CLINIC.topHeading")}
      />
      <div className="body_content py-5">
        <div className="inner_body ">
          <ul className="list-unstyled list_specialist">
            {!Boolean(isReschedule) ? (
              <>
                {/* Show only default clinic */}
                {filteredClinics?.map((clinic) => {
                  return (
                    <li>
                      <Link
                        to="#"
                        onClick={() => {
                          selectClinic(clinic.code);
                          nextStep();
                        }}
                        className={clinicId === clinic.code ? "active" : null}
                      >
                        {clinicTranslationMap.hasOwnProperty(clinic.code)
                          ? t(clinicTranslationMap[clinic.code])
                          : clinic.name}
                      </Link>
                    </li>
                  );
                })}
                <li>
                  <Link
                    to="#"
                    onClick={() => {
                      if (isOnlineAppointmentAvailable) {
                        selectClinic("CC000000");
                        nextStep();
                      }
                    }}
                    {...(!isOnlineAppointmentAvailable
                      ? {
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#modal_online",
                        }
                      : {})}
                  >
                    {t("appointment.CLINIC.clinic0")}
                  </Link>
                </li>
              </>
            ) : isOnline === "true" ? (
              <li>
                <Link
                  to="#"
                  onClick={() => {
                    if (isOnlineAppointmentAvailable) {
                      selectClinic("CC000000");
                      nextStep();
                    }
                  }}
                  {...(!isOnlineAppointmentAvailable
                    ? {
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#modal_online",
                      }
                    : {})}
                >
                  {t("appointment.CLINIC.clinic0")}
                </Link>
              </li>
            ) : (
              <>
                {availableClinics?.map((clinic) => {
                  return (
                    <li>
                      <Link
                        to="#"
                        onClick={() => {
                          selectClinic(clinic.code);
                          nextStep();
                        }}
                        className={clinicId === clinic.code ? "active" : null}
                      >
                        {clinicTranslationMap.hasOwnProperty(clinic.code)
                          ? t(clinicTranslationMap[clinic.code])
                          : clinic.name}
                      </Link>
                    </li>
                  );
                })}
              </>
            )}
          </ul>
        </div>
      </div>
      <div className="custom_modal modal fade text-center" id="modal_kalyan">
        <div className="modal-dialog d-flex align-items-center top-0">
          <div className="modal-content">
            <div className="modal-header border-bottom-0">
              <button
                id="modal_physio"
                type="button"
                className="btn-close btn-dark-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="content_modal text-start p-2">
                <h3 className="maintitle maintitle_txt_color_black text-center">
                  {t("appointment.CLINIC.kalyan")}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="custom_modal modal fade text-center" id="modal_online">
        <div className="modal-dialog d-flex align-items-center top-0">
          <div className="modal-content">
            <div className="modal-header border-bottom-0">
              <button
                id="modal_physio"
                type="button"
                className="btn-close btn-dark-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="content_modal text-start p-2">
                <h3 className="maintitle maintitle_txt_color_black text-center">
                  {t("appointment.CLINIC.online")}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SelectClinicStep;
